import IframeResizer from '@rio-cloud/iframe-resizer';
import { RioNotifications } from '@rio-cloud/rio-notifications-component';
import { OrderChat } from '@rio-cloud/rio-order-chat-component';
import ApplicationHeader from '@rio-cloud/rio-uikit/ApplicationHeader';
import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import { DefaultUserMenu, EulaConsent } from '@rio-cloud/rio-user-menu-component';
import { get } from 'lodash/fp';
import type { JSX } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { NavLink } from 'react-router';

import { getIdToken, type IdToken, type UserProfileType } from '../../configuration';
import { getUserProfile } from '../../configuration/login/selectors';
import type { State } from '../../reducers';
import { ReleaseNotesContainer } from '../serviceInformation/ReleaseNotes.container';

const serviceInfoItem = <ReleaseNotesContainer />;
const getHomeRoute = get('config.homeRoute');

interface ApplicationHeaderProperties {
    idToken: IdToken;
    homeRoute: string;
    userProfile: UserProfileType | null;
}

const AppHeader = (props: ApplicationHeaderProperties): JSX.Element => {
    const appTitle = <FormattedMessage id={'intl-msg:timed.common.module.name'} />;
    const tenant = props.userProfile?.tenant || 'unknown';
    const notifications = <RioNotifications />;
    const chat = <OrderChat tenant={tenant} />;
    const environment = import.meta.env.PROD ? 'production' : 'local';
    const userMenu = <DefaultUserMenu environment={environment} />;
    const navItems = [
        {
            key: 'realtime',
            route: (
                <NavLink to={'/realtime'}>
                    <FormattedMessage id={'intl-msg:timed.common.subModuleName.realtime'} />
                </NavLink>
            ),
        },
    ];
    const appNavigator = (
        <IframeResizer
            title='RIO application menu'
            className='iFrameResizer'
            src='https://menu.rio.cloud/'
            allowedOrigins='any'
        />
    );

    return (
        <ApplicationLayout.Header>
            <ApplicationHeader
                label={appTitle}
                homeRoute={<a href={props.homeRoute} />}
                appNavigator={appNavigator}
                navItems={navItems}
                actionBarItems={[serviceInfoItem, chat, notifications, userMenu]}
            />
            <EulaConsent environment={environment} />
        </ApplicationLayout.Header>
    );
};

const mapStateToProps = (state: State): ApplicationHeaderProperties => ({
    idToken: getIdToken(state),
    homeRoute: getHomeRoute(state),
    userProfile: getUserProfile(state),
});

export const ApplicationHeaderContainer = connect(mapStateToProps)(AppHeader);
